export default "__VITE_ASSET__D4U79rfV__"